<script>
  import AccordionGroup from "../Components/Accordion/AccordionGroup.svelte";
  import AccordionItem from "../Components/Accordion/AccordionItem.svelte";

  export let title, parentId;
</script>

<AccordionGroup {title} {parentId}>
  <AccordionItem>
    <div slot="header">What do I need to renew my registration online?</div>
    <div slot="content">
      You will need your Renewal Reminder with the Renewal Identification Number
      and the Verification Code. If you do not have the Renewal Reminder you can
      renew your registration with the Last 4 Digits of your Vehicle
      Identification Number (VIN), License Plate Number and Zip Code. You will
      need a valid credit card or electronic check information for payment.
    </div>
  </AccordionItem>
  <AccordionItem>
    <div slot="header">
      What If I did not receive a Renewal Notice in the mail?
    </div>
    <div slot="content">
      You can renew your registration with the Last 4 Digits of your Vehicle
      Identification Number (VIN), License Plate Number and Zip Code. When
      renewing ensure that your address is up to date for the Registration
      Renewal.
    </div>
  </AccordionItem>
  <AccordionItem>
    <div slot="header">How long will it take to process my renewal?</div>
    <div slot="content">
      Please allow a minimum of 5 business days for mail delivery of your
      decal(s).
    </div>
  </AccordionItem>
  <AccordionItem>
    <div slot="header">
      Is there an additional cost to renew my registration online?
    </div>
    <div slot="content">
      There is no additional charge to use STAR to renew your vehicle
      registration.
    </div>
  </AccordionItem>
  <AccordionItem>
    <div slot="header">What is the system availability schedule?</div>
    <div slot="content">STAR is available 7 days a week, 24 hours a day.</div>
  </AccordionItem>
  <slot />
</AccordionGroup>
